export default __webpack_public_path__ + "static/media/recs-mapa.1b3cce54.png";